export default function socket(
  state = {
    instances: null,
    current: null,
    api: null,
  },
  action
) {
  switch (action.type) {
    case 'SOCKET_CONNECT':
      return { ...state, instances: action.sockets };
    case 'SOCKET_SET_CURRENT':
      return { ...state, current: action.current };
    case 'API_SOCKET_CONNECT':
      return { ...state, api: action.api };
    case 'SOCKET_DISCONNECT':
      return { ...state, instances: null, current: null, api: null };
    default:
      return state;
  }
}
